<template>
    <div class="prompt" :class="{ 'prompt': true, 'active': show }">
        <div class="prompt-content">
            <div class="prompt-content-header">
            <span class="prompt-content-header-close" @click="cancel()">
              <i aria-hidden="true" class="icon icon-close-large"></i>
            </span>
            </div>
            <div class="prompt-content-body">
                <div class="row">
                    <div class="col-lg-12">
                        <h3>{{ options.title }}</h3>
                        <div class="prompt-content-body-text">
                            {{ options.message }}
                        </div>
                        <div class="button-wrapper-center">
                            <span :class="{ 'button-warn': options.warning, 'loading': loading }" @click="proceed()">{{ options.okText }}</span>
                            <span class="button-hollow" @click="cancel()">{{ options.cancelText }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    mounted () {
      let self = this
      setTimeout(() => {
        self.show = true
      }, 100)
    },
    data: function () {
      return {
        input: '',
        show: false,
        loading: false,
        closed: false
      }
    },
    props: {
      options: {
        type: Object,
        required: true
      },
      escapeKeyClose: {
        type: Boolean,
        'default': false
      }
    },
    watch: {
      'escapeKeyClose': function (val) {
        if (val === true) {
          this.cancel()
        }
      }
    },
    computed: {
      loaderEnabled () {
        return !!this.options.loader
      }
    },
    methods: {
      proceed () {
        if (this.loaderEnabled) {
          this.switchLoadingState(true)
          this.options.promiseResolver({
            close: this.close,
            loading: this.switchLoadingState
          })
        } else {
          this.options.promiseResolver(true)
          this.close()
        }
      },
      cancel () {
        if (this.loading === true) {
          return
        }
        this.options.promiseRejecter(false)
        this.close()
      },
      switchLoadingState (loading = null) {
        if (loading === null) {
          loading = !this.loading
        }

        this.loading = !!loading
      },
      close () {
        this.show = false
        this.closed = true
      }
    },
    beforeDestroy () {
      if (this.closed === false) {
        this.cancel()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/prompt/components/dialog-window.vue